import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'

const Box = styled.div`
  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.3rem;
  font-weight: 300;
  border-bottom: 1px solid var(--light-gray);
`

const Icon = styled.button`
  display: block;
  background: transparent;
  color: var(--gray);
  cursor: pointer;
  &:hover {
    color: var(--dark-gray);
  }
`

export default class Title extends Component {
  render() {
    const { str, onClose } = this.props

    return (
      <Box>
        <Text str={str} />
        <Icon className="fas fa-times" onClick={onClose} />
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/Title.js